var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.9,7.7l-2.8,4.9c-0.3,0.5-0.9,0.7-1.4,0.4l-0.3-0.2l-4.6-2.6c-0.2-0.1-0.4-0.3-0.5-0.6c-0.1-0.3,0-0.5,0.1-0.8 c0.3-0.5,0.9-0.7,1.4-0.4l3,1.7C18.5,9,17.8,7.9,17,7c-1.3-1.3-3.1-2-5-2S8.4,5.7,7,7s-2,3.1-2,5s0.7,3.6,2,5 c2.7,2.7,7.2,2.7,9.9,0c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4C16.6,20.1,14.3,21,12,21c-2.3,0-4.6-0.9-6.4-2.6C3.9,16.7,3,14.4,3,12 s0.9-4.7,2.6-6.4S9.6,3,12,3s4.7,0.9,6.4,2.6c1.1,1.1,1.8,2.4,2.3,3.8l1.5-2.7c0.3-0.5,0.9-0.6,1.3-0.4C24,6.6,24.1,7.2,23.9,7.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/icon-refresh.fd433e288aed80f90855522ebc139133.svg";
export { ForwardRef as ReactComponent };